module.exports = __webpack_public_path__ + "3c1f3301b7ccaadd6ae4776e1fd0afb0.png";